<script setup lang="ts">
defineProps({
  text: String,
});
const open = ref(false);
</script>

<template>
  <UTooltip :text="text" arrow :content="{side: 'top'}" :delay-duration="0" :ui="{content: 'bg-yellow-100 font-mono border-primary ring-1 ring-primary rounded-xs', arrow: 'fill-primary stroke-primary'}" v-model:open="open">
    <slot></slot>
  </UTooltip>
</template>

<style scoped>

</style>
